export default (prevContent) => {
    const content = JSON.parse(JSON.stringify(prevContent));
    content.compress = true;
    content.version = '1.3';
    content.header = prevContent.header;
    content.footer = prevContent.footer;

    return content;
};